import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { getOfferImageLink } from 'lib/image';
import { formatOfferPageDescription, formatOfferPageTitle } from 'lib/offer';

const Head = ({
  isIndexActive = true,
  offerTitle,
  offerPrice,
  offerPublished = null,
  offerPhoto,
  storeName = null,
  storeDomain = null,
}) => {
  const description = formatOfferPageDescription({
    offerPublishedDate: offerPublished,
    storeUrl: storeDomain,
    offerTitle,
    offerPrice,
    storeName,
  });

  return (
    <NextSeo
      description={description}
      nofollow={!isIndexActive}
      noindex={!isIndexActive}
      openGraph={{
        title: formatOfferPageTitle(offerTitle, offerPrice),
        description: description,
        images: [
          {
            url: getOfferImageLink(offerPhoto, 268),
            alt: formatOfferPageTitle(offerTitle, offerPrice),
            height: 300,
            width: 300,
          },
        ],
      }}
      title={formatOfferPageTitle(offerTitle, offerPrice)}
    />
  );
};

Head.propTypes = {
  offerTitle: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPublished: PropTypes.string,
  offerPhoto: PropTypes.string.isRequired,
  storeName: PropTypes.string,
  storeDomain: PropTypes.string,
};

export default Head;
